import React, { useState } from 'react';

// Import all testimonial images
import TestimonialBallard from '../assets/images/testimonials/TUT---HD-1-25-Political-SpotlightRep-Ballard.png';
import TestimonialCulter from '../assets/images/testimonials/TUT---HD-1-25-Political-SpotlightRep-Culter.png';
import TestimonialHall from '../assets/images/testimonials/TUT---HD-1-25-Political-SpotlightRep-Hall.png';
import TestimonialKPeterson from '../assets/images/testimonials/TUT---HD-1-25-Political-SpotlightRep.-K_Peterson.png';
import TestimonialKoford from '../assets/images/testimonials/TUT---HD-1-25-Political-SpotlightRep.-Koford.png';
import TestimonialLisonbee from '../assets/images/testimonials/TUT---HD-1-25-Political-SpotlightRep.-Lisonbee.png';
import TestimonialSawyer from '../assets/images/testimonials/TUT---HD-1-25-Political-SpotlightRep.-Sawyer.png';
import TestimonialWard from '../assets/images/testimonials/TUT---HD-1-25-Political-SpotlightRep.-Ward.png';
import TestimonialActon from '../assets/images/testimonials/TUT---HD-26-50-Political-SpotlightRep.-Acton.png';
import TestimonialFiefia from '../assets/images/testimonials/TUT---HD-26-50-Political-SpotlightRep.-Fiefia.png';
import TestimonialFitisemanu from '../assets/images/testimonials/TUT---HD-26-50-Political-SpotlightRep.-Fitisemanu.png';
import TestimonialMauga from '../assets/images/testimonials/TUT---HD-26-50-Political-SpotlightRep.-Mauga.png';
import TestimonialMiller from '../assets/images/testimonials/TUT---HD-26-50-Political-SpotlightRep.-Miller.png';
import TestimonialKayChristofferson from '../assets/images/testimonials/TUT---HD-51-75-Political-SpotlightRep.-Kay-Christofferson.png';
import TestimonialMonson from '../assets/images/testimonials/TUT---HD-51-75-Political-SpotlightRep.-Monson.png';
import TestimonialRoberts from '../assets/images/testimonials/TUT---HD-51-75-Political-SpotlightRep.-Roberts.png';
import TestimonialShelley from '../assets/images/testimonials/TUT---HD-51-75-Political-SpotlightRep.-Shelley.png';
import TestimonialShipp from '../assets/images/testimonials/TUT---HD-51-75-Political-SpotlightRep.-Shipp.png';
import TestimonialThurston from '../assets/images/testimonials/TUT---HD-51-75-Political-SpotlightRep.-Thurston.png';
import TestimonialWalter from '../assets/images/testimonials/TUT---HD-51-75-Political-SpotlightRep.-Walter.png';
import TestimonialWelton from '../assets/images/testimonials/TUT---HD-51-75-Political-SpotlightRep.-Welton.png';
import TestimonialCannon from '../assets/images/testimonials/TUT---Leadership-SpotlightAuditor-Cannon.png';
import TestimonialBalderree from '../assets/images/testimonials/TUT---SD-1-29-Political-SpotlightSen.-Balderree.png';
import TestimonialOwens from '../assets/images/testimonials/TUT---SD-1-29-Political-SpotlightSen.-Owens.png';
import TestimonialPitcher from '../assets/images/testimonials/TUT---SD-1-29-Political-SpotlightSen.-Pitcher.png';
import TestimonialWeiler from '../assets/images/testimonials/TUT---SD-1-29-Political-SpotlightSen.-Weiler.png';
import TestimonialWinterton from '../assets/images/testimonials/TUT---SD-1-29-Political-SpotlightSen.-Winterton.png';

interface TestimonialImage {
  src: string;
  alt: string;
  name: string;
}

const testimonialImages: TestimonialImage[] = [
  { src: TestimonialBallard, alt: 'Rep. Ballard Testimonial', name: 'Rep. Ballard' },
  { src: TestimonialCulter, alt: 'Rep. Culter Testimonial', name: 'Rep. Culter' },
  { src: TestimonialHall, alt: 'Rep. Hall Testimonial', name: 'Rep. Hall' },
  { src: TestimonialKPeterson, alt: 'Rep. K. Peterson Testimonial', name: 'Rep. K. Peterson' },
  { src: TestimonialKoford, alt: 'Rep. Koford Testimonial', name: 'Rep. Koford' },
  { src: TestimonialLisonbee, alt: 'Rep. Lisonbee Testimonial', name: 'Rep. Lisonbee' },
  { src: TestimonialSawyer, alt: 'Rep. Sawyer Testimonial', name: 'Rep. Sawyer' },
  { src: TestimonialWard, alt: 'Rep. Ward Testimonial', name: 'Rep. Ward' },
  { src: TestimonialActon, alt: 'Rep. Acton Testimonial', name: 'Rep. Acton' },
  { src: TestimonialFiefia, alt: 'Rep. Fiefia Testimonial', name: 'Rep. Fiefia' },
  { src: TestimonialFitisemanu, alt: 'Rep. Fitisemanu Testimonial', name: 'Rep. Fitisemanu' },
  { src: TestimonialMauga, alt: 'Rep. Mauga Testimonial', name: 'Rep. Mauga' },
  { src: TestimonialMiller, alt: 'Rep. Miller Testimonial', name: 'Rep. Miller' },
  { src: TestimonialKayChristofferson, alt: 'Rep. Kay Christofferson Testimonial', name: 'Rep. Kay Christofferson' },
  { src: TestimonialMonson, alt: 'Rep. Monson Testimonial', name: 'Rep. Monson' },
  { src: TestimonialRoberts, alt: 'Rep. Roberts Testimonial', name: 'Rep. Roberts' },
  { src: TestimonialShelley, alt: 'Rep. Shelley Testimonial', name: 'Rep. Shelley' },
  { src: TestimonialShipp, alt: 'Rep. Shipp Testimonial', name: 'Rep. Shipp' },
  { src: TestimonialThurston, alt: 'Rep. Thurston Testimonial', name: 'Rep. Thurston' },
  { src: TestimonialWalter, alt: 'Rep. Walter Testimonial', name: 'Rep. Walter' },
  { src: TestimonialWelton, alt: 'Rep. Welton Testimonial', name: 'Rep. Welton' },
  { src: TestimonialCannon, alt: 'Auditor Cannon Testimonial', name: 'Auditor Cannon' },
  { src: TestimonialBalderree, alt: 'Sen. Balderree Testimonial', name: 'Sen. Balderree' },
  { src: TestimonialOwens, alt: 'Sen. Owens Testimonial', name: 'Sen. Owens' },
  { src: TestimonialPitcher, alt: 'Sen. Pitcher Testimonial', name: 'Sen. Pitcher' },
  { src: TestimonialWeiler, alt: 'Sen. Weiler Testimonial', name: 'Sen. Weiler' },
  { src: TestimonialWinterton, alt: 'Sen. Winterton Testimonial', name: 'Sen. Winterton' },
];

const TestimonialsCarousel: React.FC = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState<number>(0);
  const [isTransitioning, setIsTransitioning] = useState<boolean>(false);
  
  // Calculate total number of slides (groups of 3)
  const totalSlides = Math.ceil(testimonialImages.length / 3);
  
  // Get current slide images
  const getCurrentSlideImages = (slideIndex: number): TestimonialImage[] => {
    const startIndex = slideIndex * 3;
    return testimonialImages.slice(startIndex, startIndex + 3);
  };
  
  const [currentSlide, setCurrentSlide] = useState<TestimonialImage[]>(getCurrentSlideImages(0));

  // Function to change slide with fade transition
  const changeSlide = (newSlideIndex: number) => {
    if (isTransitioning || newSlideIndex === currentSlideIndex) return;
    
    setIsTransitioning(true);
    
    // Fade out current slide
    setTimeout(() => {
      setCurrentSlideIndex(newSlideIndex);
      setCurrentSlide(getCurrentSlideImages(newSlideIndex));
      
      // Fade in new slide
      setTimeout(() => {
        setIsTransitioning(false);
      }, 50);
    }, 300);
  };

  // No auto-advance - removed useEffect intervals

  const handleNext = () => {
    const nextIndex = (currentSlideIndex + 1) % totalSlides;
    changeSlide(nextIndex);
  };

  const handlePrev = () => {
    const prevIndex = currentSlideIndex === 0 ? totalSlides - 1 : currentSlideIndex - 1;
    changeSlide(prevIndex);
  };
  
  const handleDotClick = (slideIndex: number) => {
    changeSlide(slideIndex);
  };

  return (
    <div className="testimonials-carousel mt-4">
      <div className="row g-3">
        {currentSlide.map((testimonial, index) => (
          <div key={`${testimonial.name}-${index}`} className="col-lg-4 col-md-12 col-sm-12">
            <div className="testimonial-card">
              <img
                src={testimonial.src}
                alt={testimonial.alt}
                className="img-fluid rounded"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '600px',
                  objectFit: 'contain',
                  opacity: isTransitioning ? 0 : 1,
                  transition: 'opacity 0.3s ease-in-out'
                }}
              />
            </div>
          </div>
        ))}
      </div>
      
      {/* Navigation */}
      <div className="d-flex justify-content-center align-items-center mt-4">
        {/* Previous Arrow */}
        <button
          className="btn btn-link p-0 me-3"
          onClick={handlePrev}
          style={{ 
            color: 'var(--tu-primary-black)', 
            textDecoration: 'none',
            fontSize: '1.5rem',
            border: 'none'
          }}
          disabled={isTransitioning}
          aria-label="Go Back"
        >
          ←
        </button>
        
        {/* Dots Navigation */}
        <div className="d-flex align-items-center">
          {Array.from({ length: totalSlides }, (_, index) => (
            <button
              key={index}
              className="btn btn-link p-0 mx-1"
              onClick={() => handleDotClick(index)}
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: index === currentSlideIndex ? 'var(--tu-primary-black)' : 'rgba(0,0,0,0.3)',
                border: 'none',
                transition: 'background-color 0.3s ease'
              }}
              disabled={isTransitioning}
              aria-label="Dot navigation"
            />
          ))}
        </div>
        
        {/* Next Arrow */}
        <button
          className="btn btn-link p-0 ms-3"
          onClick={handleNext}
          style={{ 
            color: 'var(--tu-primary-black)', 
            textDecoration: 'none',
            fontSize: '1.5rem',
            border: 'none'
          }}
          disabled={isTransitioning}
          aria-label="Go Forward"
        >
          →
        </button>
      </div>
    </div>
  );
};

export default TestimonialsCarousel;